import {useEffect} from 'react'
import {Outlet, useNavigate, useParams} from 'react-router-dom'
import {doREQUEST_PROJECT_FETCH} from '../../store'
import {AdherenceType} from '../organisms'
import {useCurrentProjectState} from '../../engine'
import {ProjectSwitchBar} from '../molecules'

export const AdherencePage = () => {
  // console.log('render AdherencePage') // test code

  const navigate = useNavigate()
  const {adherenceType} = useParams()
  const {projectId, project} = useCurrentProjectState()
  useEffect(() => {
    if (adherenceType) {
      if (!project) {
        doREQUEST_PROJECT_FETCH({
          payload: {
            projectId,
          },
        })
      }
      if (!Object.values(AdherenceType).includes(adherenceType as AdherenceType)) {
        navigate(`/adherence/${projectId}/${AdherenceType.Overview}`)
      }
    } else {
      navigate(`/adherence/${projectId}/${AdherenceType.Overview}`)
    }
  }, [])

  return (
    <div
      css={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}>
      <ProjectSwitchBar projectPanel='Adherence' />
      {/* adherence table block will be mounted here */}
      <Outlet />
    </div>
  )
}
